import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import frame1 from "../../Assets/Frames/frame1.png"; // adjust path
import frame2 from "../../Assets/Frames/frame2.png"; // adjust path

export default function SelectFrame() {
  const [selectedFrame, setSelectedFrame] = useState("1");
  const navigate = useNavigate();

  const { bg } = useParams();

  const handleNext = () => {
    navigate(`/capture/${bg}/${selectedFrame}`);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        height: "96dvh",
        alignItems: "center",
      }}
    >
      <div
        style={{
          top: "20px",
          color: "#fff",
          textAlign: "center",
          fontSize: "28px",
          fontWeight: "bold",
          width: "100%",
        }}
      >
        Select Frame
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        {/* Frame 1 */}
        <div
          onClick={() => setSelectedFrame("1")}
          style={{ width: "40%", textAlign: "center" }}
        >
          <img
            src={frame1}
            alt="Background 1"
            width={"100%"}
            style={{
              border: selectedFrame === "1" ? "2px solid blue" : "none",
            }}
          />
          <input
            type="radio"
            name="frame"
            value="1"
            checked={selectedFrame === "1"}
            onChange={(e) => setSelectedFrame(e.target.value)}
            style={{
              transform: "scale(2)",
              margin: "10px",
            }}
          />
        </div>

        {/* BG 2 */}
        <div
          onClick={() => setSelectedFrame("2")}
          style={{ width: "40%", textAlign: "center" }}
        >
          <img
            src={frame2}
            alt="Background 2"
            width={"100%"}
            style={{
              border: selectedFrame === "2" ? "2px solid blue" : "none",
            }}
          />
          <input
            type="radio"
            name="frame"
            value="2"
            checked={selectedFrame === "2"}
            onChange={(e) => setSelectedFrame(e.target.value)}
            style={{
              transform: "scale(2)",
              margin: "10px",
            }}
          />
        </div>
      </div>
      {/* Next button appears only after selecting */}
      <button
        className="rippleBtn"
        disabled={!bg}
        onClick={handleNext}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        Next
      </button>
    </div>
  );
}
